// extracted by mini-css-extract-plugin
export var addressFields = "_pc-0";
export var animationContainer = "_pc-1";
export var footer = "_pc-2";
export var lineItems = "_pc-3";
export var modalContent = "_pc-4";
export var orderName = "_pc-5";
export var strong = "_pc-6";
export var warning = "_pc-7";